import articleTypes from "astrid-firestore/src/api/articles/constants/articleTypes";

import getDocumentData from "../../src/utils/getDocumentData";

import createArticleDelivery from "./createArticleDelivery";
import createAudioArtifact from "./createAudioArtifact";
import createChannels from "./createChannels";
import createCover from "./createCover";
import createDocumentIdAndRef from "./createDocumentIdAndRef";

export default async function createAudiobooksFromMulti({ api, env }, { production, publisher, commonArticleData }) {
	const fullPublisherDocRef = api.convertFromLiveToStage
		? api.stage.db.collection("organizations").doc(publisher.id)
		: api[env].db.collection("organizations").doc(publisher.id);
	const fullPublisherDoc = await getDocumentData(fullPublisherDocRef);
	return await Promise.all(
		production.deliveryParts.map(async (part, index) => {
			const { id, ref } = createDocumentIdAndRef({ api, env }, { collection: "articles" });
			const isNotASeries = !production.deliveryPartsTitle && !production.series && !production.part;
			const article = {
				...commonArticleData,
				id,
				ref,
				type: articleTypes.AUDIOBOOK,
				isbn: part.isbn,
				synopsis: part.synopsis || production.synopsis || "",
				name: isNotASeries ? production.title : part.title,
				subtitle: isNotASeries ? part.title : "",
				serieNumber: isNotASeries ? null : index + 1,
				bokgruppe: production.bokgruppe?.toString() || null,
			};
			const cover = await createCover(
				{ api, env },
				{
					img: production.deliveryPartsCover?.[index]?.img,
				},
			);
			const coverThumb = await createCover(
				{ api, env },
				{
					img: production.deliveryPartsCover?.[index]?.imgThumb,
				},
			);
			const artifact = await createAudioArtifact(
				{ api, env },
				{
					production,
					article,
					articleType: `part_${index}`,
				},
			);
			const duration = artifact?.files?.reduce?.((sum, file) => sum + file.duration, 0) || 0;
			const { channels, channelIds } = await createChannels(
				{ api, env },
				{
					article,
					fullPublisherDoc,
					production,
					articleType: `part_${index}`,
				},
			);

			const delivery = createArticleDelivery({ channels, channelIds });
			return {
				...article,
				artifact,
				cover,
				coverThumb,
				duration,
				channels,
				channelIds,
				delivery,
			};
		}),
	);
}
